import gql from "graphql-tag";

export default gql`
  subscription subscribeToControllerFinished($concreteShipmentId: Int!) {
    subscribeToControllerFinished(
      concreteShipmentId: $concreteShipmentId,
    )
  }
`;
